import { render, staticRenderFns } from "./ProductsInHopperItem.vue?vue&type=template&id=74f78b06"
import script from "./ProductsInHopperItem.vue?vue&type=script&lang=js"
export * from "./ProductsInHopperItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports